export function isOffScreenFeedbackTarget(
  targetDocumentId: string | undefined,
  openDocumentId: string,
): boolean {
  return targetDocumentId != null && targetDocumentId !== openDocumentId;
}
